import debug from 'debug';
import {APP_SETTINGS} from 'ro-webapp-backend';

const log = debug('ro-webapp:jsonRequest');

export default class JsonRequest {
    constructor(url, options) {
        //TODO: not working!!!!!
        //this.url = AppState.state.settings[APP_SETTINGS.BASE_URL].replace(/\/$/, '') + url;
        this.url = url;
        this.options = options;
        this.cancelled = false;
    }

    cancel() {
        this.cancelled = true;
    }

    async fetch() {
        log(`Fetching ${this.url}, options: `, this.options);
        return fetch(this.url, this.options)
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (this.cancelled) {
                log(`Request ${this.url} cancelled`);
                return Promise.reject({cancelled: true})
            }
            return response;
        })
    }
}


// WEBPACK FOOTER //
// ./src/core/jsonRequest.js